import { useGraphqlQuery } from "@mzara/component"
import { TAppointment } from "@mzara/graphql"
import { AppointmentOwnerQuery } from "../query/AppointmentOwnerQuery"

export const useAppointmentOwnerQuery = (id?: number, suspense?: boolean) => {
    return useGraphqlQuery<AppointmentOwnerQuery, TAppointment>(new AppointmentOwnerQuery({ id }), { enabled: id !== undefined, suspense })
}